import * as z from "zod";
import { requiredString } from "components/form/utils";

export const testimonialSchema = z.object({
  feedback: requiredString(),
  // Directus file id (string) when loaded, File when a new one is picked.
  video: z
    .any()
    .refine(
      (v) =>
        v === null ||
        v === undefined ||
        typeof v === "string" ||
        (typeof File !== "undefined" && v instanceof File),
      { message: "Invalid file" }
    )
    .optional()
    .nullable(),
  review_url: z
    .string()
    .url("Invalid review URL")
    .optional()
    .or(z.literal(""))
    .nullable(),
});
